import { render, staticRenderFns } from "./CreateBonusPointSettings.vue?vue&type=template&id=65130a13&scoped=true&"
import script from "./CreateBonusPointSettings.vue?vue&type=script&lang=js&"
export * from "./CreateBonusPointSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65130a13",
  null
  
)

export default component.exports